import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
const CASES = [{
  client: 'Porto Seguro',
  project: 'Experiencia de marca con pantallas LED para un encuentro corporativo.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/a3a411d5-8991-4ef1-9460-0dc16546ca76.jpg'
}, {
  client: 'Verdirrojo BBC',
  project: 'Cobertura audiovisual y contenidos para acompañar la temporada deportiva.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/b00001f8-ac9c-4a65-bdcd-2ec3aa830aea.jpg'
}, {
  client: 'Los Álamos',
  project: 'Fotografía y comunicación visual para experiencias de hospitalidad.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/bc96e757-158c-4bc4-9486-651eb819f1ca.jpg'
}, {
  client: 'Luces Pro',
  project: 'Producción técnica, cámaras y visuales para espectáculos en vivo.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/e089bcce-961e-4e9f-801b-d1a04a965b2d.jpg'
}, {
  client: 'SoClean',
  project: 'Contenido de producto y fotografía comercial para redes.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/f08e3dd2-2795-44b0-a246-52d12e0dcbbc.jpg'
}, {
  client: 'Nacional Fútbol Club',
  project: 'Soluciones visuales y cobertura para una experiencia de transmisión deportiva.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/367c1d3b-abd2-4041-b4c2-9424b216f8b1.jpg'
}, {
  client: 'La Farola',
  project: 'Fotografía, gráfica y señalética para una experiencia de marca gastronómica.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/cdda8a6a-24cf-41ab-9590-1798b487681d.jpg'
}];
export function Clients() {
  return <section id="clientes" className="w-full bg-vm-cream py-28 lg:py-36" data-id="element-24" data-mp="3qe61huuaamqv">
      <div className="max-w-7xl mx-auto px-6 lg:px-10" data-id="element-25" data-mp="3qbtaks6jt21o">
        <div className="max-w-4xl" data-id="element-26" data-mp="3v5o1afkkmha9">
          <SectionLabel tone="blue" data-id="element-27" data-mp="3v6pdwoh8jbu3">Casos de éxito</SectionLabel>
          <h2 className="mt-6 font-syne text-4xl font-bold leading-[1.03] text-vm-bg sm:text-5xl lg:text-[56px]" data-id="element-28" data-mp="8u5rihe0in7d">
            Clientes que eligieron hacer visible su proyecto
          </h2>
          <p className="mt-6 max-w-2xl text-lg font-light leading-relaxed text-vm-navy" data-id="element-29" data-mp="3v1m5v0hxpf9b">
            Una selección de producciones y soluciones visuales desarrolladas para marcas, instituciones y equipos que buscan conectar con su audiencia.
          </p>
        </div>

        <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-30" data-mp="3hbaex4x35mjr">
          {CASES.map((caseStudy, index) => <motion.article key={caseStudy.client} initial={{
          opacity: 0,
          y: 22
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: index % 3 * 0.07
        }} className="overflow-hidden border border-vm-bg bg-white" data-id="element-31" data-mp="3cb4jddnp3fwe" data-mpi={index}>
              <img src={caseStudy.image} alt={`Proyecto realizado para ${caseStudy.client}`} className="aspect-[4/3] w-full object-cover" data-id="element-32" data-mp="1du3zzwk33a24" />
              <div className="border-t border-vm-bg/20 p-6" data-id="element-33" data-mp="1mv1wlts70fao">
                <p className="text-xs font-medium uppercase tracking-[0.25em] text-vm-electric" data-id="element-34" data-mp="1mvlejahuf3op">Caso de éxito</p>
                <h3 className="mt-3 font-syne text-2xl font-semibold text-vm-bg lg:text-[28px]" data-id="element-35" data-mp="1rrsl95i2cj7p">{caseStudy.client}</h3>
                <p className="mt-3 font-light leading-relaxed text-vm-navy" data-id="element-36" data-mp="z57ofpitjewr">{caseStudy.project}</p>
              </div>
            </motion.article>)}
        </div>

        <p className="mt-10 border-t border-vm-bg/25 pt-5 text-sm font-light text-vm-navy" data-id="element-37" data-mp="1427s5ts745kp">
          Estamos sumando nuevos casos y alianzas a esta selección.
        </p>
      </div>
    </section>;
}